import type { RouteObject } from 'react-router-dom';
import LoginPage from '../pages/login/page';
import DashboardPage from '../pages/dashboard/page';
import ChangePasswordPage from '../pages/profile/change-password/page';

// 仅保留不依赖菜单权限的基础路由，业务路由由后端菜单动态生成。
const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/', element: <DashboardPage /> },
  { path: '/profile/change-password', element: <ChangePasswordPage /> },
];

export default routes;
